import type { LicenseDataMap } from '@gcv/shared';
import { injectable } from 'inversify';
import { action, makeAutoObservable } from 'mobx';

import { GcvAdminApi } from 'api';

@injectable()
export class ComplianceStore {
  licenseDataMap = {} as LicenseDataMap;
  isLoaded = false;

  constructor() {
    makeAutoObservable(this);
  }

  gcvAdminApi = new GcvAdminApi();

  setLicenseDataMap = action((licenseData: LicenseDataMap) => {
    this.licenseDataMap = licenseData;
  });

  clearStore = action(() => {
    this.licenseDataMap = {} as LicenseDataMap;
    this.isLoaded = false;
  });
}

let store: ComplianceStore | undefined;

export function getComplianceStore(): ComplianceStore {
  if (!store) {
    store = new ComplianceStore();
  }

  return store;
}
